class MobileMenu extends HTMLElement {
  constructor() {
    super();
  }
  getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }
  scrollLock() {
    const scrollBarWidth = this.getScrollbarWidth();
    this.lastScrollPosition = window.scrollY;
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.paddingRight = `${scrollBarWidth}px`;
    document.body.style.position = "fixed";
    document.body.style.left = 0;
    document.body.style.width = '100%';
  }
  scrollUnlock() {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.paddingRight = "";
    document.body.style.left = "";
    document.body.style.width = "";
    window.scrollTo({top: this.lastScrollPosition, behavior: "instant"});
  }
  close() {
    this.scrollUnlock();
    this.removeAttribute('open');
  }
  open() {
    this.scrollLock();
    this.setAttribute('open', '');
  }
  disconnectedCallback() {
  }
  connectedCallback() {
    this.addEventListener('click', e => {
      if(e.target === this) {
        this.close();
      }
    });
    const toggles = document.querySelectorAll('[data-mobile-menu-trigger]');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', e => {
        if(this.hasAttribute('open')) {
          this.close();
        } else {
          this.open();
        }
      });
    });
    const close_buttons = document.querySelectorAll('[data-mobile-menu-close]');
    close_buttons.forEach(close_button => {
      close_button.addEventListener('click', e => {
        this.close();
      });
    });
    const menu_close_buttons = this.querySelectorAll('[data-menu-close]');
    menu_close_buttons.forEach(menu_close_button => {
      menu_close_button.addEventListener('click', e => {
        const menu_id = menu_close_button.dataset.menuClose;
        const target_menu = this.querySelector(`[data-menu-target="${menu_id}"]`);
        target_menu?.classList.remove('active');
      });
    });
    const menu_open_buttons = this.querySelectorAll('[data-menu-open]');
    menu_open_buttons.forEach(menu_open_button => {
      menu_open_button.addEventListener('click', e => {
        const menu_id = menu_open_button.dataset.menuOpen;
        const target_menu = this.querySelector(`[data-menu-target="${menu_id}"]`);
        this.querySelector('.mobile-menu-inner').scrollTo({top: 0, left: 0, behavior: 'instant'});
        target_menu?.classList.add('active');
      });
    });
    this.querySelector('[data-trigger-search]')?.addEventListener('click', e => {
      const visibleSearchPopdowns = Array.from(document.querySelectorAll('search-popdown[data-popdown-in-header]')).filter(e => !!e.offsetParent);
      const firstVisiblePopdown = visibleSearchPopdowns?.pop()?.querySelector('[data-popdown-toggle]');
      this.close();
      if(firstVisiblePopdown) {
        this.addEventListener("transitionend", e => {
            firstVisiblePopdown.click();
          },
          { 
            once: true
          }
        );
      }
    });
  }
}
if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu);
}